class LoopingElement {
	constructor(element, currentTranslation, speed, reverse = false) {
		this.element = element
		this.currentTranslation = currentTranslation
		this.speed = speed
		this.direction = reverse ? false : true
		this.scrollTop = 0
		this.metric = 100
		this.reverse = reverse

		this.lerp = {
			current: this.currentTranslation,
			target: this.currentTranslation,
			factor: 0.2,
		}

		this.events()
		this.render()
	}

	events() {
		window.addEventListener('scroll', e => {
			let scrollPos = window.scrollY || document.documentElement.scrollTop
			let direction = scrollPos - this.scrollTop

			if (this.reverse) {
				direction = 0 - direction
			}

			this.direction = direction > 0
			this.lerp.target += this.speed * (direction / 3)
			this.scrollTop = scrollPos <= 0 ? 0 : scrollPos
		})
	}

	lerpFunc(current, target, factor) {
		this.lerp.current = current * (1 - factor) + target * factor
	}

	goForward() {
		this.lerp.target += this.speed
		if (this.lerp.target > this.metric) {
			this.lerp.current -= this.metric * 2
			this.lerp.target -= this.metric * 2
		}
	}

	goBackward() {
		this.lerp.target -= this.speed
		if (this.lerp.target < -this.metric) {
			this.lerp.current -= -this.metric * 2
			this.lerp.target -= -this.metric * 2
		}
	}

	animate() {
		this.direction ? this.goForward() : this.goBackward()
		this.lerpFunc(this.lerp.current, this.lerp.target, this.lerp.factor)

		this.element.style.transform = `translateX(${this.lerp.current}%)`
	}

	render() {
		this.animate()
		window.requestAnimationFrame(() => this.render())
	}
}

let imagesArray = document.querySelectorAll('.logo-ticker .line-1 ul')
new LoopingElement(imagesArray[0], 0, 0.02, false)
new LoopingElement(imagesArray[1], -100, 0.02, false)

let imagesArray2 = document.querySelectorAll('.logo-ticker .line-2 ul')
new LoopingElement(imagesArray2[0], 0, 0.02, true)
new LoopingElement(imagesArray2[1], -100, 0.02, true)
